import React, { Component } from 'react';
import './CodeSystemSidebar.css';
import { QueryCSContext } from '../contexts/QueryCSContext';
// import { GlobalContext } from '../contexts/GlobalContext';
import FilterSummary from '../Filters/FilterSummary';
// import CodeSystemFilters from './CodeSystemFilters';
import CSStatusFilter from './CSStatusFilter';
import Button from '@material-ui/core/Button';
import CSTitleFilter from './CSTitleFilter';
import CSTagFilter from './CSTagFilter';

class CodeSystemSidebar extends Component {
	static contextType = QueryCSContext;

	handleClick() {
		document.getElementById('codeSystemBody__id').scroll({ top: 0, behavior: 'auto' });
	}

	render() {
		return (
			<QueryCSContext.Consumer>
				{(queryCSContext) => (
					<div className="codeSystemSidebar">
						<div className="codeSystemSidebar__filters">
							<FilterSummary
								count={String((queryCSContext.bundle.total === null || queryCSContext.bundle.total === undefined) ? "0" : queryCSContext.bundle.total)}
								type="Code Systems"
							/>
							<CSStatusFilter />
							<CSTitleFilter />
							<CSTagFilter />
							<Button
								variant="contained"
								size="small"
								color="primary"
								onClick={(x) => {
									this.handleClick();
									queryCSContext.getData();
								}}
								className="filter__button"
							>Filter Data</Button>
						</div>
					</div>
				)}
			</QueryCSContext.Consumer>
		);
	}
}

export default CodeSystemSidebar;
